import { Link, useNavigate } from "react-router-dom";

import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import { FaRegEye } from "react-icons/fa6";
import { FaRegEyeSlash } from "react-icons/fa6";
import axios from "axios";
import toast from "react-hot-toast";
import { object, string, } from "yup";
import { useDispatch } from 'react-redux';
import { setToken } from '../../store/token.slice';
import AuthHeroSection from "./AuthHeroSection";
import AuthLangButton from "../../components/authLangButton/AuthLangButton";
import parse from 'html-react-parser';
import { useTranslation } from "react-i18next";


export default function Register() {

  const passwordRef = useRef<HTMLInputElement>(null)
  const closeEyeRef = useRef<HTMLSpanElement>(null)
  const openEyeRef = useRef<HTMLSpanElement>(null)
  const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
  const phoneRegex = /^5\d{8}$/
  const baseUrl = import.meta.env.VITE_BASE_URL
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const lang = i18n.language
  const [termsDataEN, setTermsDataEN] = useState("");
  const [termsDataAR, setTermsDataAR] = useState("");
  const [termsOpen, setTermsOpen] = useState(false);

  function toggleTerms() {
    setTermsOpen(!termsOpen);
  }





  // validationSchema
  const validationSchema = object({
    email: string().email(t("register.emailInvalid") as string).required(t("register.emailRequired") as string),
    password: string().min(8, t("register.passwordMin") as string).required(t("register.passwordRequired") as string).matches(passwordRegex, t("register.passwordComplexity") as string),
    userName: string().required(t("register.usernameRequired") as string).min(3, t("register.usernameMin") as string),
    phone: string()
      .notRequired()
      .test(
        "is-valid-phone",
        t("register.invalidPhone") as string,
        (value) => !value || phoneRegex.test(value)
      )
  })

  // register user function
  async function registerUser() {
    const toastId = toast.loading(t("register.loading") as string)
    try {
      const options = {
        url: `${baseUrl}/api/dashboard/users/register?locale=${lang}`,
        method: "POST",
        data: {
          username: formik.values.userName,
          email: formik.values.email,
          password: formik.values.password,
          phone: formik.values.phone === "" ? undefined : formik.values.phone
        }

      }
      const response = await axios.request(options)
      if (response.data.success == true) {
        toast.success(t("register.success") as string)
        navigate("/activate-account")
        dispatch(setToken(response.data.activateToken));
      } else if (response.data.success == false) {
        toast.error(response.data.error)
      }
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        toast.error(error.response.data.error)
      } else {
        toast.error("An unexpected error occurred")
      }
    } finally {
      toast.dismiss(toastId)
    }
  }

  // controlled input 
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      userName: "",
      phone: ""
    },
    validationSchema,
    onSubmit: registerUser
  })

  // password visibiblity function
  function togglePasswordVisibility() {
    if (passwordRef.current) {
      if (passwordRef.current.type === "password") {
        passwordRef.current.type = "text"
        openEyeRef.current?.classList.remove("hidden")
        closeEyeRef.current?.classList.add("hidden")

      } else {
        passwordRef.current.type = "password"
        openEyeRef.current?.classList.add("hidden")
        closeEyeRef.current?.classList.remove("hidden")
      }
    }
  }

  async function getTerms() {
    try {
      const response = await axios.get(`${baseUrl}/api/dashboard/settings/static-pages/terms-and-conditions/?locale=${lang}`)

      setTermsDataAR(response.data.contentAR)
      setTermsDataEN(response.data.contentEN)
    } catch (error) {
      console.error(error);
    }
  }
  useEffect(() => {
    getTerms()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <>
      {termsOpen && <div onClick={toggleTerms} className="fixed z-[99] inset-0 bg-black bg-opacity-50 px-10 flex items-center justify-center">
        <div onClick={(e) => e.stopPropagation()} className="p-5 bg-white  max-h-[80vh] rounded-md flex flex-col gap-5 justify-center items-center">
          <h3 className="font-semibold my-2"> {t("register.terms")}</h3>
          <div className="text-center overflow-auto thin-scrollbar px-5 text-semibold max-w-[700px]">
            {lang === "ar" ? parse(termsDataAR) : parse(termsDataEN)}

          </div>
          <button onClick={toggleTerms} className="my-btn self-end w-fit px-5 py-2"> {t("register.close")}</button>
        </div>
      </div>}
      <div className="xl:grid xl:grid-cols-12 ">
        <form
          onSubmit={formik.handleSubmit}
          className=" h-[90vh] relative mt-10 flex justify-evenly  flex-col  col-span-4 "
        >

          <div className="w-[70%] mx-auto" >
            <AuthLangButton />
          </div>
          <div className="w-[90%] md:w-[60%] xl:w-[70%] overflow-y-auto mx-auto">
            <div className="flex flex-col gap-1 w-full   p-5">

              <h1 className="  text-xl font-semibold">
                {t("register.welcome")}🚀
              </h1>
              <span className="text-slate-400">{t("register.makeManging")}</span>

              <div className="flex w-full  flex-col gap-3">
                <div className="flex flex-col gap-2">
                  <label htmlFor="" className="font-semibold">{t("register.username")}</label>
                  <input
                    onBlur={formik.handleBlur}
                    value={formik.values.userName}
                    onChange={formik.handleChange}
                    name="userName"
                    type="text"
                    className="input" placeholder={t("register.usernamePlaceholder") as string} />
                  {formik.errors.userName && formik.touched.userName && <span className="text-red-500">{formik.errors.userName}</span>}
                </div>
                <div className="flex flex-col gap-2">
                  <label htmlFor="email" className="font-semibold">{t("register.email")}</label>
                  <input
                    onBlur={formik.handleBlur}
                    placeholder={t("register.email") as string}
                    onChange={formik.handleChange}
                    value={formik.values.email}
                    name="email"
                    type="email"
                    className="input"
                  />
                  {formik.errors.email && formik.touched.email && <span className="text-red-500">{formik.errors.email}</span>}
                </div>
                <div className="flex flex-col gap-2 relative">
                  <label htmlFor="" className="font-semibold">{t("register.password")}</label>
                  <input
                    placeholder={t("register.password") as string}
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    ref={passwordRef}
                    name="password"
                    type="password"
                    className="input"
                    onBlur={formik.handleBlur}
                  />

                  <span
                    ref={openEyeRef}
                    className={`absolute hidden ${lang === "ar" ? "left-2" : "right-2"} bottom-3 text-slate-400 cursor-pointer`}
                    onClick={togglePasswordVisibility}
                  >
                    <FaRegEye />
                  </span>

                  <span
                    ref={closeEyeRef}
                    className={`absolute ${lang === "ar" ? "left-2" : "right-2"} bottom-3 text-slate-400 cursor-pointer`}
                    onClick={togglePasswordVisibility}
                  >
                    <FaRegEyeSlash />
                  </span>

                </div>
                {formik.errors.password && formik.touched.password && <span className="text-red-500">{formik.errors.password}</span>}
                <div className="flex flex-col gap-2 relative">
                  <label htmlFor="" className="font-semibold">{t("register.phone")}</label>
                  <input
                    onBlur={formik.handleBlur}
                    value={formik.values.phone}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (value.startsWith("0")) {
                        value = value.substring(1); // Remove leading zero
                      }
                      formik.setFieldValue("phone", value);
                    }}
                    name="phone"
                    type="tel"
                    placeholder={t("register.phone") as string}
                    className="input ps-16"
                  />

                  <span className="absolute  left-2 bottom-2 text-slate-400">{t("+966", "+966")}</span>
                </div>
                {formik.errors.phone && formik.touched.phone && <span className="text-red-500">{formik.errors.phone}</span>}

                <div className="flex flex-wrap items-center gap-3 ">
                  {t("register.agreementPrefix")} <span onClick={toggleTerms} className="text-sidebar cursor-pointer hover:underline pt-1 font-semibold">{t("register.terms")}
                  </span>
                </div>
                <button type="submit" className="my-btn">
                  {t("register.register")}
                </button>

                <div className="flex justify-center items-center gap-2">
                  <span>  {t("register.alreadyHaveAccount")}  </span>
                  <Link to={'/login'} className="text-sidebar">
                    {t("register.login")}                  </Link>
                </div>
              </div>
            </div>
          </div>
        </form>
        <AuthHeroSection />
      </div>
    </>
  )
}

